import { PropsWithChildren } from 'react';

import { FieldWrapper, FieldWrapperEndAdornmentProps } from '../field-wrapper';

export type PercentageAdornmentProps = {
  size?: FieldWrapperEndAdornmentProps['size'];
};

export function PercentageAdornment({ children, size }: PropsWithChildren<PercentageAdornmentProps>) {
  return (
    <FieldWrapper>
      {children}
      <FieldWrapper.EndAdornment size={size}>
        <span className="text-secondary text-sm">%</span>
      </FieldWrapper.EndAdornment>
    </FieldWrapper>
  );
}
